import { List } from "immutable";
import { isFunction } from "lodash";

import hasAncestorOfClass from "../../utils/hasAncestorOfClass";

const getDropdownOptions = options => {
  const opts = isFunction(options) ? options() : options;
  return List.isList(opts) ? opts.toArray() : opts;
};

const clickWasDropdown = e => hasAncestorOfClass(e.target, "dropdownMenu");

const findMatchTextFromOption = (option, searchText) => {
  const lowerSearch = searchText.toLowerCase();
  const { label, displayId } = option;
  return (
    (label && label.toLowerCase().indexOf(lowerSearch) >= 0) ||
    (displayId && displayId.toLowerCase().indexOf(lowerSearch) >= 0)
  );
};

const getFilteredOptions = (options, searchText) => {
  if (options) {
    const filterOptionArray = optArr => {
      return optArr.reduce((filteredArr, opt) => {
        if (findMatchTextFromOption(opt, searchText)) {
          filteredArr.push(opt);
        } else if (opt.children) {
          const filteredChildren = filterOptionArray(opt.children);
          if (filteredChildren.length > 0) {
            opt.children = filteredChildren;
            filteredArr.push(opt);
          }
        }
        return filteredArr;
      }, []);
    };
    return filterOptionArray(options);
  }
  return [];
};

export { clickWasDropdown, getDropdownOptions, getFilteredOptions };
